import {
  createUnitCalendarSlot,
  getFirstWeekSlots,
  getWeek,
} from '../../../../../../../Modules/Calendar/Helpers/Calendar'
import moment from 'moment'

export const recomputeSlots = (enrollmentSlots, firstSlot) => {
  const firstWeekSlots = getFirstWeekSlots(enrollmentSlots)
  const picked = firstWeekSlots.map(({ startTime }) => {
    const start = new Date(startTime)
    return {
      day: start.getDay() - 1,
      index: start.getHours() * 2 + start.getMinutes() / 30,
    }
  })

  const slots = []

  let classesLeft = enrollmentSlots.length,
    iteration = 0

  while (classesLeft > 0) {
    let clashed = false

    const someDayOfTheWeek = new Date(firstWeekSlots[0].startTime)
    someDayOfTheWeek.setDate(someDayOfTheWeek.getDate() + iteration * 7)
    const currentWeek = getWeek(someDayOfTheWeek)

    picked
      .slice(!iteration ? firstSlot : 0, classesLeft)
      .forEach(({ day, index }) => {
        const slot = createUnitCalendarSlot(
          new Date(currentWeek[day < 0 ? day + 7 : day].getTime()).setHours(
            0,
            index * 30,
            0,
            0,
          ),
          'pickedSlot',
          null,
          60 * 60 * 1000,
        )

        slots.push(slot)
      })

    if (clashed) {
      return false
    }

    classesLeft -= !iteration ? picked.length - firstSlot : picked.length
    iteration++
  }

  return slots.map(({ exactStartTime, exactEndTime }) => ({
    startTime: exactStartTime,
    endTime: exactEndTime,
  }))
}

export const getBatchLayoutData = (slots) => {
  const weeks = {}
  const days = new Set()

  slots.forEach(({ startTime, endTime }) => {
    const start = moment(startTime)

    weeks[start.week()] = weeks[start.week()] || {}
    weeks[start.week()][start.day()] = weeks[start.week()][start.day()] || []
    weeks[start.week()][start.day()].push({ startTime, endTime })

    days.add(start.day())
  })

  return {
    data: weeks,
    days: [...days]
      .sort()
      .map((i) => ({ index: i, day: moment.weekdays()[i] })),
  }
}
